import React, { createContext, useContext, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(() => {
    const token = localStorage.getItem('adminToken');
    const username = localStorage.getItem('adminUsername');
    return token ? { token, username } : null;
  });

  const updateAdminSession = (token, username) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminUsername', username);
    setAdmin({ token, username });
  };

  const login = async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    updateAdminSession(data.token, data.username);
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUsername');
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, updateAdminSession }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
